export default "__VITE_ASSET__ChxcZxUD__"